import { useTranslation } from "react-i18next";

export const useLanguage = () => {
  const { i18n } = useTranslation();
  const isRTL = (i18n.resolvedLanguage || i18n.language || "en")
    .toLowerCase()
    .startsWith("ar");

  return {
    language: i18n.language,
    isRTL,
    direction: isRTL ? ("rtl" as const) : ("ltr" as const),
    changeLanguage: i18n.changeLanguage,
  };
};
